import { ENTER_KEY, TAB_KEY } from '../../../const/keyNames';
export const handleShowHideKeyDown = (event, setTypeValue, typeValue, clickFocus) => {
    if (event.key === TAB_KEY || (event.shiftKey && event.key === TAB_KEY))
        return;
    if (event.shiftKey)
        event.preventDefault();
    if (event.key === ENTER_KEY) {
        event.preventDefault();
        setTypeValue(typeValue === 'password' ? 'text' : 'password');
        clickFocus();
    }
};
export const handleShowHideMouseDown = (event, clickFocus) => {
    event.stopPropagation();
    event.preventDefault();
    clickFocus();
};
export const handleShowHideMouseUp = (setTypeValue, typeValue) => {
    setTypeValue(typeValue === 'password' ? 'text' : 'password');
};
export const handleOnBlur = ({ event, onBlur, setTelPlaceholder, isInputTypeTel }) => {
    if (isInputTypeTel) {
        setTelPlaceholder('');
    }
    if (typeof onBlur === 'function') {
        onBlur(event);
    }
};
export const handleOnFocus = ({ event, setTelPlaceholder, isInputTypeTel, onFocus }) => {
    if (isInputTypeTel) {
        setTelPlaceholder('(___) ___ - ___');
    }
    event.preventDefault();
    if (onFocus) {
        onFocus(event);
    }
};
export const handleOnChange = ({ event, matchPattern, onChange }) => {
    if (!matchPattern) {
        onChange(event);
        return;
    }
    const pattern = new RegExp(matchPattern);
    if (pattern.test(event.target.value)) {
        onChange(event);
    }
};
//# sourceMappingURL=helpers.js.map